import './index.scss';
import {isGutenbergEditorVisible} from "../../src/scripts/helpers";
import {getUrlWithSerializedForm} from "../../src/scripts/helpers";
import AnimationMagnetic from "../../src/scripts/modules/animation-magnetic";

function init(scope = document) {
    const nodeSelectors = {
        container: '[js-activities="container"]',

        // Filters
        filters: '[js-activities="filters"]',
        filtersResetButton: '[js-activities="filters-reset-button"]',
        filtersResponseHolder: '[js-activities="filters-response-holder"]',
        filtersResponse: '[js-activities="filters-response"]',
        filtersForm: '[js-activities="filters-form"]',
        filtersPageInput: '[js-activities="filters-page-input"]',
        filtersLoadMoreButton: '[js-activities="filters-load-more-button"]',
        filtersLoadMoreButtonHolder: '[js-activities="filters-load-more-button-holder"]',
        filtersInput: '[js-activities="filters-input"]',
        filtersButton: '[js-activities="filters-button"]',
        filtersLoader: '[js-activities="filters-loader"]',
        filtersIsLoadMore: '[js-activities="filters-is-load-more"]',
        filtersCurrentCategory: '[js-activities="filters-current-category"]',
    }

    const containers = scope.querySelectorAll(nodeSelectors.container);

    if (!containers.length) return;

    containers.forEach((container) => {
        let filtersResetButton = container.querySelector(nodeSelectors.filtersResetButton)
        let filtersButton = container.querySelectorAll(nodeSelectors.filtersButton)
        let filtersInput = container.querySelectorAll(nodeSelectors.filtersInput)
        let filtersLoadMoreButtonHolder = container.querySelector(nodeSelectors.filtersLoadMoreButtonHolder)
        let filtersLoadMoreButton = container.querySelector(nodeSelectors.filtersLoadMoreButton)
        let filtersPageInput = container.querySelector(nodeSelectors.filtersPageInput)
        let filtersIsLoadMore = container.querySelector(nodeSelectors.filtersIsLoadMore)
        let filtersResponseHolder = container.querySelector(nodeSelectors.filtersResponseHolder)
        let filtersResponse = container.querySelector(nodeSelectors.filtersResponse)
        let filtersLoader = container.querySelectorAll(nodeSelectors.filtersLoader)
        let filtersForm = container.querySelector(nodeSelectors.filtersForm)
        let filtersCurrentCategory = container.querySelector(nodeSelectors.filtersCurrentCategory)

        jQuery(filtersInput).on('change', function (e) {
            resetPageNumber()
            jQuery(filtersIsLoadMore).val("0")
            filterPosts(false)
            jQuery(filtersResponseHolder).addClass("posts-holder--filtered-category")
        })

        jQuery(container).on('click', nodeSelectors.filtersButton, function (e) {
            let target = this.getAttribute('data-target')
            jQuery(filtersCurrentCategory).text(jQuery(this).text())

            filtersInput.forEach(input => {
                if( input.value === target ) {
                    jQuery(input).prop('checked', true)
                    jQuery(input).trigger('change')
                }
            })
        })

        jQuery(filtersResetButton).on('click', function (e) {
            jQuery(filtersResponseHolder).removeClass("posts-holder--filtered-category")
            jQuery(filtersIsLoadMore).val("0")
            resetPageNumber()

            filtersInput.forEach(input => {
                jQuery(input).prop('checked', false)
            })

            filterPosts(false)
        })

        jQuery(filtersLoadMoreButton).on('click', function(){
            let tmp = parseInt(jQuery(filtersPageInput).val())
            tmp++
            jQuery(filtersPageInput).val(tmp)
            jQuery(filtersIsLoadMore).val("1")
            filterPosts(true)
        });

        function filterPosts(loadMore = false) {
            if( !loadMore ) {
                filtersResponse.classList.add("posts--loading");
            }

            // Show loader
            jQuery(filtersLoader).show()

            jQuery.ajax({
                url: site_data.site_url + "/wp-admin/admin-ajax.php",
                data: jQuery(filtersForm).serialize(),
                type: "GET",
                beforeSend: function (xhr) {},
                success: function (data) {
                    let objData = JSON.parse(data);

                    if( !objData.next_page_posts ) {
                        hideLoadMoreBtn();
                    } else {
                        showLoadMoreBtn();
                    }

                    if( loadMore ) {
                        filtersResponse.innerHTML += objData.html;
                    } else {
                        jQuery(filtersResponse).html(objData.html);
                    }
                },
                error: function (error) {
                    console.log(error)
                },
                complete: function (data) {
                    filtersResponse.classList.remove("posts--loading");

                    // let objData = JSON.parse(data);

                    // Remove loader
                    jQuery(filtersLoader).fadeOut()

                    // Remove loading state
                    jQuery(filtersResponse).removeClass("loading");

                    if( loadMore ) {
                        jQuery('.post-holder--newly-loaded').slideDown(250);
                    } else {
                        // Return to top of posts
                        jQuery("html, body").stop().animate({scrollTop: jQuery(nodeSelectors.container).position().top - 50 }, 300, 'swing', function () {
                            // setTimeout(function () {
                            //     SiteHeader().hide()
                            // }, 20)
                        });
                    }

                    setTimeout(function () {
                        AnimationMagnetic().init()
                    }, 200)

                    // Set new url
                    history.pushState(null, null, getUrlWithSerializedForm(jQuery(filtersForm)));
                },
            });
        }

        function hideLoadMoreBtn() {
            jQuery(filtersLoadMoreButtonHolder).slideUp()
        }

        function showLoadMoreBtn() {
            jQuery(filtersLoadMoreButtonHolder).slideDown()
        }

        function resetPageNumber() {
            jQuery(filtersPageInput).val('1');
        }
    });
}

document.addEventListener('DOMContentLoaded', () => {
    if (window.acf) {
        window.acf.addAction('render_block_preview/type=activities', ($block) => {
            const blockEl = $block[0] || $block;

            setTimeout(function() {
                init(blockEl);
            }, 100)
        });
    } else if( !isGutenbergEditorVisible() ) {
        init()
    }
});